import { useMemo } from 'react';
import { translations } from '../constants/translations';

export const useTranslations = componentName =>
  useMemo(() => translations.en[componentName], [componentName]);
